import { render, staticRenderFns } from "./BusinessType.vue?vue&type=template&id=798a4183&scoped=true&"
import script from "./BusinessType.vue?vue&type=script&lang=js&"
export * from "./BusinessType.vue?vue&type=script&lang=js&"
import style0 from "./BusinessType.vue?vue&type=style&index=0&id=798a4183&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798a4183",
  null
  
)

export default component.exports